import axios from 'axios';
import history from './history';

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
	baseURL: API_URL,
	timeout: 10000,
	headers: {
		Authorization: localStorage.getItem('access_token')
			? 'Bearer ' + localStorage.getItem('access_token')
			: null,
		'Content-Type': 'application/json',
		accept: 'application/json',
	}, 
});

axiosInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	async function (error) {
		const originalRequest = error.config;

		if (typeof error.response === 'undefined') {
			alert('Please restart server and client');
			return Promise.reject(error);
		}

		if (error.response.status === 401 && originalRequest.url === API_URL + '/api/users/refresh/') {
            localStorage.clear();
			history.push("/");
			return Promise.reject(error);
		}

		if (
			error.response.data.code === 'token_not_valid' &&
			error.response.status === 401 &&
			error.response.statusText === 'Unauthorized'
		) {
			const refreshToken = localStorage.getItem('refresh_token');

			if (refreshToken) {
				const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));
				const now = Math.ceil(Date.now() / 1000);

				if (tokenParts.exp > now) {
					return axiosInstance
						.post('/api/users/refresh/', { refresh: refreshToken })
						.then((response) => {
							localStorage.setItem('access_token', response.data.access);
							axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + response.data.access;
							originalRequest.headers['Authorization'] = 'Bearer ' + response.data.access;
							return axiosInstance(originalRequest);
						})
						.catch((err) => {
							// added later
							localStorage.clear();
                    		history.push("/");
						});
				} else {
					localStorage.clear();
                    history.push("/");
				}
			} else {
                localStorage.clear();
				history.push("/");
			}
		}
		return Promise.reject(error);
	}
);

export default axiosInstance;